import * as React from "react";
import { useTranslation } from "react-i18next";

export default function OrderTesting() {
  const { t } = useTranslation()
  
  return (<>{t("menu.orderTesting")}</>)
}